import React, { useContext } from 'react'

import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl'
import FilterSearch from '../../Filter/FilterSearch';
import { ORDER_DESCENDING } from '../../../constants';

const Filters = ({ filters, setFilters, applyFilters, resetFilters, appliedFilters }) => {
    const intl = useIntl();

    const setFilterState = (value, field) => {
        setFilters(old => {
            const copy = _.cloneDeep(old);
            copy[field] = value
            return copy
        })
    }
    const handleSearchKeyDown = (event) => {
        if (event.key === 'Enter') {
            applyFilters();
        }
    };

    return (
        <div className=''>
            <div className='container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-x-5 gap-y-3'>

                <div onKeyDown={handleSearchKeyDown}>
                <FilterSearch
                    placeholder={intl?.formatMessage({ id: "search", defaultMessage: "Search" })}
                    label_text={intl?.formatMessage({ id: "search", defaultMessage: "Search" })}
                    setState={(value) => setFilterState(value, "search")}
                    state={filters.search}

                />
                </div>
             
                {/* <SelectAPIField
                    isClearable={true}
                    state={filters.department}
                    setState={(value) => setFilterState(value, "department")}
                    label_text="Department"
                    placeholder="Department"
                    url="api/department"
                    valueGenerator={val => ({ label: val.name ? val.name : "-", value: val })}
                /> */}
                {/* <FilterSelect
                    placeholder={intl.formatMessage({ id: "all", defaultMessage: "All" })}
                    label_text={intl.formatMessage({ id: "status", defaultMessage: "Status" })}
                    options={IS_ACTIVE}
                    setState={(value) => setFilterState(value, "lab_status")}
                    state={filters.lab_status}
                /> */}
                {/* <FilterSelect
                    disableClearable={true}
                    placeholder={intl.formatMessage({ id: "order_by", defaultMessage: "Order By" })}
                    label_text={intl.formatMessage({ id: "order_by", defaultMessage: "Order By" })}
                    options={SORT_ORDERS}
                    setState={(value) => setFilterState(value, "sort_order")}
                    state={filters.sort_order}
                /> */}

                <div className="flex items-end z-0">
                    <button
                        disabled={!(appliedFilters.search || appliedFilters?.lab_status || appliedFilters?.department || appliedFilters.sort_order.value !== ORDER_DESCENDING.value)}
                        onClick={resetFilters}
                        type="button"
                        className={`w-full col-span-2 btn !py-2 !px-4 h-[42px] !text-sm btn-secondary z-0`}
                    >
                        
                            <FormattedMessage id="reset_filters" defaultMessage={"Reset Filters"} />
                        
                    </button>
                </div>
                <div className="flex items-end">
                    <button
                        disabled={
                            filters.search.trim() === appliedFilters.search.trim()
                                &&
                                filters.lab_status?.value === appliedFilters.lab_status?.value
                                &&
                                filters.department?.value === appliedFilters.department?.value
                                &&
                                filters.sort_order?.value === appliedFilters.sort_order?.value
                                ?
                                true
                                :
                                false
                        }
                        onClick={applyFilters}
                        type="button"
                        className='w-full col-span-2 btn !py-2 !px-4 h-[42px] !text-sm btn-primary'
                    >
                        <p className='relative'>
                            <FormattedMessage id="apply_filters" defaultMessage={"Apply Filters"} />
                        </p>
                    </button>
                </div>
            </div>

        </div>
    )
}

export default Filters